import { loadStripe } from '@stripe/stripe-js/pure';

let stripePromise = null;

export const useLoadStripe = () => {
  if (!stripePromise) {
    loadStripe.setLoadParameters({ advancedFraudSignals: false });
    stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);
  }
  return { stripePromise };
};
